import type { ReactElement } from "react";
import { IconProps, SvgIcon } from "./SvgIcon";

export function MagnifierIcon({
  className,
  color = "currentColor",
  size,
}: IconProps): ReactElement {
  return (
    <SvgIcon size={size} className={className}>
      <circle cx="11" cy="11" r="8" stroke={color} strokeWidth="2" />
      <path
        d="M17 17L21 21"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
}
